import React from 'react';
import {MapContainer} from 'react-leaflet'
import 'leaflet/dist/leaflet.css';

import Map from './Map';

import {Container} from 'react-bootstrap';

import './GettingHere.scss';

const data = {center: [26.53706, 54.02471], zoom: 16 }

const GettingHere = () => {

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <div id="pageGettingHere" className="flex-grow-1 d-flex">
            <Container fluid className="px-0 d-flex map">
                <MapContainer center={data.center} zoom={data.zoom} scrollWheelZoom={true} zoomControl={false} style={{width: '100%'}}>
                    <Map data={data}/>
                </MapContainer>
            </Container>
        </div>
    )
}

export default GettingHere;